import React from 'react';
import { Box, FiservCardInterface, getUtcDate, Text } from '@common-fe/common-fe';

import { DEFAULT_DATE_FORMAT } from '@/common/constants';

interface Props {
  card: FiservCardInterface;
}

const EMPTY_DATE = '-';
export const CardDetailsTable: React.FC<Props> = ({ card }) => (
  <Box
    background="canvas"
    round="container1Round"
    direction="row"
    pad="spacing12"
    border={{ size: 'small', color: 'border2' }}
    elevation="default"
  >
    <Box flex="grow" direction="column" justify="between" pad="spacing12">
      <Box margin={{ bottom: 'spacing24' }} direction="row" justify="between">
        <Text color="textSecondary">Card Request Date:</Text>
        <Text weight="bold" data-testid="CardDetailsTable-cardRequestDate">
          {
            card.cardRequestDate
              ? getUtcDate(card.cardRequestDate).format(DEFAULT_DATE_FORMAT)
              : EMPTY_DATE
          }
        </Text>
      </Box>
      <Box direction="row" justify="between">
        <Text color="textSecondary">Mailed Date:</Text>
        <Text weight="bold" data-testid="CardDetailsTable-mailedDate">
          {
            card.mailedDate
              ? getUtcDate(card.mailedDate).format(DEFAULT_DATE_FORMAT)
              : EMPTY_DATE
          }
        </Text>
      </Box>
    </Box>
    <Box border={{ side: 'left' }} />
    <Box flex="grow" direction="column" justify="between" pad="spacing12">
      <Box margin={{ bottom: 'spacing24' }} direction="row" justify="between">
        <Text color="textSecondary">Activation Date:</Text>
        <Text weight="bold" data-testid="CardDetailsTable-activationDate">
          {
            card.activationDate
              ? getUtcDate(card.activationDate).format(DEFAULT_DATE_FORMAT)
              : EMPTY_DATE
          }
        </Text>
      </Box>
      <Box direction="row" justify="between">
        <Text color="textSecondary">Expiration Date:</Text>
        <Text weight="bold" data-testid="CardDetailsTable-expDate">
          {
            card.expDate
              ? getUtcDate(card.expDate).format(DEFAULT_DATE_FORMAT)
              : EMPTY_DATE
          }
        </Text>
      </Box>
    </Box>
  </Box>
);
